<template>
  <div
    :id="pageId"
    class="pate-content"
    :class="pageId"
  >
    <card-container
      :disabled="isSubmitBtnDisabled"
      :is-loading="isLoading"
      loading-message="Loading NeedLove Form..."
      @submit="submitForm"
      @reset="resetForm"
    >
      <template #title>
        Update NeedLove Form
      </template>

      <template #submit-button>
        Update
      </template>

      <template #additional-buttons>
        <p-button
          type="yellow"
          round
          @click="backToSearch"
        >
          Back to NeedLove Search
        </p-button>
      </template>

      <template #content>
        <fieldset>
          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> FormStack ID </label>
            <div class="col-sm-8 mobile-pb-10">
              <p>
                {{ formData.formstackId }}
                <a
                  class="ml-10"
                  :href="`https://www.formstack.com/admin/submission/view/${formData.formstackId}`"
                  target="_blank"
                >
                  Open on FormStack
                </a>
              </p>
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Created At </label>
            <div class="col-sm-8 mobile-pb-10">
              <p>{{ formData.createdAt }}</p>
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Updated At </label>
            <div class="col-sm-8 mobile-pb-10">
              <p>{{ formData.updatedAt }}</p>
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Operator Name </label>
            <div class="col-sm-8 mobile-pb-10">
              <p>{{ formData.operatorsName }}</p>
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Complaint Type </label>
            <div class="col-sm-8 mobile-pb-10">
              <p>{{ util.getLabelByField(complaintTypeList, formData.natureOfComplaint) }}</p>
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Status of Complaint * </label>
            <div class="col-sm-8 mobile-pb-10">
              <dropdown-list
                id="statusOfComplaint"
                v-model="formData.statusOfComplaint"
                name="statusOfComplaint"
                required
                filterable
                clearable
                :options="statusOfComplaintList"
              />
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Customer Name * </label>
            <div class="col-sm-8 mobile-pb-10">
              <sanitized-input
                :id="`customersName-${pageId}`"
                v-model="formData.customersName"
                name="customersName"
                placeholder="Please input customer's name"
                required
              />
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Caller ID * </label>
            <div class="col-sm-8 mobile-pb-10">
              <sanitized-input
                :id="`callerId-${pageId}`"
                v-model="formData.callerId"
                name="callerId"
                placeholder="Please input caller ID"
                required
              />
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Customer Current Time </label>
            <div class="col-sm-8 mobile-pb-10">
              <sanitized-input
                id="customerCurrentTime"
                v-model="formData.customerCurrentTime"
              />
            </div>
          </div>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Phone Number </label>
            <phone-number-input
              id="phoneNumber"
              v-model="formData.phoneNumber"
              class="col-sm-8 mobile-pb-10"
              :page-id="pageId"
            />
          </div>

          <div class="row">
            <label class="col-sm-3 control-label pt-5"> Customer Concern </label>
            <div class="col-sm-8 mobile-pb-10">
               <sanitized-textarea
                id="customerConcern"
                v-model="formData.customerConcern"
                autosize
              />
            </div>
          </div>

          <template v-if="isSupervisorRefundTrackingFieldsShow">
            <div class="row align-items-center">
              <label class="col-sm-3 control-label"> Mood of customer after the conversation* </label>
              <div class="col-sm-8">
                <dropdown-list
                  id="moodOfCustomer"
                  v-model="formData.moodOfCustomer"
                  name="moodOfCustomer"
                  :options="customerMoodList"
                  required
                />
              </div>
            </div>

            <div class="row align-items-center">
              <label class="col-sm-3 control-label"> Does this issue need a follow-up?* </label>
              <div class="col-sm-8">
                <dropdown-list
                  id="needFollowUp"
                  v-model="formData.needFollowUp"
                  name="needFollowUp"
                  :options="answerYesNoQuestionList"
                  required
                />
              </div>
            </div>

            <div class="row align-items-center">
              <label class="col-sm-3 control-label"> Was there a refund approved or deny?* </label>
              <div class="col-sm-8">
                <dropdown-list
                  id="wasRefundApprovedOrDeny"
                  v-model="formData.wasRefundApprovedOrDeny"
                  name="wasRefundApprovedOrDeny"
                  :options="refundApprovedDenyList"
                  required
                />
              </div>
            </div>

            <div class="row align-items-center">
              <label class="col-sm-3 control-label"> Type of Adjustment* </label>
              <div class="col-sm-8">
                <dropdown-list
                  id="adjustmentType"
                  v-model="formData.adjustmentType"
                  name="adjustmentType"
                  :options="adjustmentTypeList"
                  required
                />
              </div>
            </div>

            <template v-if="isMembershipRefundIssuedFieldsShow">
              <div class="row align-items-center">
                <label class="col-sm-3 control-label"> Membership Refund Issued* </label>
                <div class="col-sm-8">
                  <el-input
                    id="membershipRefundIssued"
                    v-model="formData.membershipRefundIssued"
                    type="number"
                    :step="0.01"
                    :min="0"
                    required
                    placeholder="2"
                  >
                    <template #prepend>
                      $
                    </template>
                  </el-input>
                </div>
              </div>

              <div class="row align-items-center">
                <label class="col-sm-3 control-label"> Membership Credits Issued* </label>
                <div class="col-sm-8">
                  <el-input
                    id="membershipCreditsIssued"
                    v-model="formData.membershipCreditsIssued"
                    type="number"
                    :step="0.01"
                    :min="0"
                    required
                    placeholder="2"
                  >
                    <template #prepend>
                      $
                    </template>
                  </el-input>
                </div>
              </div>
            </template>

            <template v-if="isRefundIssuedFieldsShow">
              <div class="row align-items-center">
                <label class="col-sm-3 control-label"> Refund Issued* </label>
                <div class="col-sm-8">
                  <el-input
                    id="refundIssued"
                    v-model="formData.refundIssued"
                    type="number"
                    :step="0.01"
                    :min="0"
                    required
                    placeholder="2"
                  >
                    <template #prepend>
                      $
                    </template>
                  </el-input>
                </div>
              </div>

              <div class="row align-items-center">
                <label class="col-sm-3 control-label"> Credits Issued* </label>
                <div class="col-sm-8">
                  <el-input
                    id="creditsIssued"
                    v-model="formData.creditsIssued"
                    type="number"
                    :step="0.01"
                    :min="0"
                    required
                    placeholder="2"
                  >
                    <template #prepend>
                      $
                    </template>
                  </el-input>
                </div>
              </div>
            </template>

            <div
              v-if="isDeniedAmountFieldShow"
              class="row align-items-center"
            >
              <label class="col-sm-3 control-label"> Amount Denied* </label>
              <div class="col-sm-8">
                <el-input
                  id="deniedAmount"
                  v-model="formData.deniedAmount"
                  type="number"
                  :step="0.01"
                  :min="0"
                  required
                  placeholder="2"
                >
                  <template #prepend>
                    $
                  </template>
                </el-input>
              </div>
            </div>
          </template>

          <div class="row align-items-center">
            <label class="col-sm-3 control-label"> Supervisor's Name </label>
            <div class="col-sm-8 mobile-pb-10">
              <sanitized-input
                id="supervisorName"
                v-model="formData.supervisorName"
              />
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 control-label pt-5"> Supervisor Notes/Updates </label>
            <div class="col-sm-8 mobile-pb-10">
              <sanitized-textarea
                id="supervisorNotesUpdates"
                v-model="formData.supervisorNotesUpdates"
                name="supervisorNotesUpdates"
                placeholder="Supervisor Notes/Updates"
              />
            </div>
          </div>
          <div class="row align-items-center justify-content-center">
            <p-button
              type="purple"
              round
              :disabled="!formData.phoneNumber"
              @click="loadForm"
            >
              Reload
            </p-button>
            <p-button
              type="purple"
              round
              :disabled="!formData.phoneNumber"
              @click="pullCustomerOnRightPanel"
            >
              Pull the customer info on RightPanel
            </p-button>
          </div>
        </fieldset>
      </template>
    </card-container>
  </div>
</template>

<script setup lang="ts">
import { Ref, computed, onMounted, ref, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import _ from 'lodash';
import delay from 'yoctodelay';
import events from '@/events';

import util from '@/Utils/util';
import { AdjustmentType, NeedLoveForm, NeedLoveFormType } from '@/models/needLove';
import {
  complaintTypeList,
  statusOfComplaintList,
  answerYesNoQuestionList,
  customerMoodList,
  refundApprovedDenyList,
  adjustmentTypeList,
} from '@/constants/needLoveOne';
import { useSwalDialog } from '@/use/swalDialog';
import { useProfile } from '@/use/profile';
import { needLoveService } from '@/services/needLove';

const route = useRoute();
const router = useRouter();

const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

const pageId = 'update-needlove-form-page';

const { userRoles } = useProfile();
const { isSupervisor } = toRefs(userRoles);

const needLoveId = ref('');
const formData: Ref<NeedLoveForm> = ref({} as NeedLoveForm);
const isLoading = ref(false);

const isSubmitBtnDisabled = computed(() => {
  if (isLoading.value) {
    return true;
  }

  return false;
});

const isSupervisorRefundTrackingFieldsShow = computed(() => isSupervisor.value && formData.value.natureOfComplaint === NeedLoveFormType.WantsToCloseAccount);
const isMembershipRefundIssuedFieldsShow = computed(() => formData.value.adjustmentType === AdjustmentType.Membership);
const isRefundIssuedFieldsShow = computed(() => formData.value.adjustmentType === AdjustmentType.NonMembership);
const isDeniedAmountFieldShow = computed(() => formData.value.adjustmentType === AdjustmentType.None);

const originalFormData = ref({} as NeedLoveForm);

const backToSearch = async () => {
  router.push({ name: 'NeedLove' });
};

const pullCustomerOnRightPanel = async () => {
  if (!formData.value.phoneNumber) return;

  router.push({ query: { phoneNumber: formData.value.phoneNumber } });

  await delay(100);
  events.emit('refresh-right-panel');
  events.emit('set-needlove-to-right-panel', {
    id: formData.value.id || '',
    formId: Number(formData.value.formstackId),
    phoneNumber: formData.value.phoneNumber,
  });
};

const loadForm = async () => {
  isLoading.value = true;

  const response = await needLoveService.getNLForm({ id: needLoveId.value });

  originalFormData.value = formatNeedLoveFormResponse(response);
  formData.value = formatNeedLoveFormResponse(response);

  isLoading.value = false;
};

const resetForm = async () => {
  formData.value = _.cloneDeep(originalFormData.value);
};

const submitForm = async () => {
  isLoading.value = true;

  const updateData = {
    ..._.omit(formData.value, ['id', 'formstackId', 'createdAt', 'updatedAt', 'operatorsName']),

    // yes/no
    needFollowUp: util.getLabelByField(answerYesNoQuestionList, formData.value.needFollowUp ?? ''),
    // lists
    natureOfComplaint: util.getLabelByField(complaintTypeList, formData.value.natureOfComplaint ?? ''),
    statusOfComplaint: util.getLabelByField(statusOfComplaintList, formData.value.statusOfComplaint ?? ''),
    adjustmentType: util.getLabelByField(adjustmentTypeList, formData.value.adjustmentType ?? ''),
    wasRefundApprovedOrDeny: util.getLabelByField(refundApprovedDenyList, formData.value.wasRefundApprovedOrDeny ?? ''),
    // supervisor membership refund tracking amount fields data
    ...(isMembershipRefundIssuedFieldsShow.value ? {
      membershipRefundIssued: Number(formData.value.membershipRefundIssued),
      membershipCreditsIssued: Number(formData.value.membershipCreditsIssued),
    } : {
      membershipRefundIssued: null,
      membershipCreditsIssued: null,
    }),
    ...(isRefundIssuedFieldsShow.value ? {
      refundIssued: Number(formData.value.refundIssued),
      creditsIssued: Number(formData.value.creditsIssued),
    } : {
      refundIssued: null,
      creditsIssued: null,
    }),
    ...(isDeniedAmountFieldShow.value ? {
      deniedAmount: Number(formData.value.deniedAmount),
    } : {
      deniedAmount: null,
    }),
  };

  try {
    const response = await needLoveService.updateNLForm({ id: needLoveId.value, data: updateData });

    if (!response) {
      return;
    }

    formData.value = formatNeedLoveFormResponse(response);
    showSuccessPopupDialog({
      text: 'The Need Love form has been updated successfully.',
    });
  } catch (err) {
    const errorText = util.getErrorResponse(err, false);
    showErrorPopupDialog({
      text: errorText,
    });
  } finally {
    isLoading.value = false;
  }
};

const formatNeedLoveFormResponse = (response: NeedLoveForm) => {
  return {
    ...response,
    membershipRefundIssued: response.membershipRefundIssued ?? 0,
    membershipCreditsIssued: response.membershipCreditsIssued ?? 0,
    refundIssued: response.refundIssued ?? 0,
    creditsIssued: response.creditsIssued ?? 0,
    deniedAmount: response.deniedAmount ?? 0,

    // yes/no
    needFollowUp: response.needFollowUp && util.getFieldByLabel(answerYesNoQuestionList, response.needFollowUp),
    // lists
    natureOfComplaint: response.natureOfComplaint && util.getFieldByLabel(complaintTypeList, response.natureOfComplaint),
    statusOfComplaint: response.statusOfComplaint && util.getFieldByLabel(statusOfComplaintList, response.statusOfComplaint),
    adjustmentType: response.adjustmentType && util.getFieldByLabel(adjustmentTypeList, response.adjustmentType),
    wasRefundApprovedOrDeny: response.wasRefundApprovedOrDeny && util.getFieldByLabel(refundApprovedDenyList, response.wasRefundApprovedOrDeny),
  };
}

onMounted(() => {
  needLoveId.value = (route.params.id as string) || '';
  loadForm();
});
</script>
